import { useCallback } from "react";
import { CommonService } from "../services/CommonService";
import { useVersionWatcher } from "./useVersionWatcher";

/**
 * Detecta cuando el backend se reinició por un deploy (GET /version cambia,
 * ver back/routes/api.php y back/.github/workflows/main.yml) y fuerza un
 * refresh del POS para que las pestañas abiertas en caja recojan los cambios
 * nuevos, en vez de quedarse corriendo contra una build vieja indefinidamente.
 */
export const useBackendVersionWatcher = () => {
  const getVersion = useCallback(async () => {
    const res = await CommonService.getBackendVersion();
    return res?.version ?? null;
  }, []);

  useVersionWatcher(getVersion, "backend");
};
